export const sitePackages = [
  {
    id: 'starter',
    name: 'Starter Website',
    price: '$900',
    description:
      'A professional brochure-style website designed to establish your online presence and make it easy for customers to contact you.',
    highlights: [
      'Custom website design',
      'Fully responsive for desktop, tablet, and mobile',
      'Home, About, Services, Gallery or Portfolio, and Contact pages',
      'Contact form',
      'Google Maps integration',
      'Social media links',
      'Basic on-page SEO',
      'Performance optimization',
      'Launch support',
    ],
    helperText: 'Perfect for small businesses establishing a clear online presence.',
  },
  {
    id: 'business',
    name: 'Growth Website',
    price: '$1,500',
    description:
      'A more feature-rich website designed to generate leads, showcase your services in depth, and streamline customer interactions.',
    highlights: [
      'Everything in Starter, plus:',
      'Expanded site architecture',
      'Individual service pages',
      'Reviews & testimonials',
      'FAQ section',
      'Booking or scheduling integration',
      'Online payment integration',
      'Lead capture improvements',
      'Analytics setup',
      'Enhanced SEO structure',
      'Additional third-party integrations',
      'More custom layouts and content sections',
    ],
    helperText: 'Perfect for growing businesses that need their site to generate leads.',
  },
  {
    id: 'growth',
    name: 'Custom Web Applications',
    price: '$3,000',
    description:
      'Custom-built software tailored to your business, from client portals to internal tools and full SaaS platforms.',
    highlights: [
      'Secure user authentication',
      'Admin dashboards',
      'Client portals',
      'Customer management systems (CRM)',
      'Custom databases',
      'Business workflow automation',
      'Online marketplaces',
      'Membership platforms',
      'SaaS applications',
      'Advanced booking systems',
      'API integrations',
      'Analytics & reporting',
      'Fully custom functionality',
    ],
    helperText: 'Perfect for businesses that need custom software, not just a website.',
  },
];

export const hostingPlans = [
  {
    id: 'self-hosted',
    name: 'Self-Hosted Handoff',
    price: 'Custom Quote',
    description:
      'Source code and production files delivered to you or deployed to your existing hosting provider. Includes basic configuration and launch assistance. Ongoing maintenance and server support are not included.',
  },
  {
    id: 'essential',
    name: 'Essential Hosting',
    price: '$25/month',
    description:
      'Secure cloud hosting, SSL certificate, automatic backups, security updates, and uptime monitoring.',
  },
  {
    id: 'hosting',
    name: 'Managed Hosting + Support',
    price: '$39/month',
    description:
      'Everything in Essential, plus minor content updates and ongoing technical support.',
  },
];

export const pricingFaqs = [
  {
    question: 'Are these fixed prices?',
    answer:
      'These are starting prices. Every project is unique and receives a personalized proposal based on its scope, functionality, and goals.',
  },
  {
    question: 'How does payment work?',
    answer:
      'Projects typically start with a deposit to begin work, with the balance due before launch. Exact schedule is confirmed in your proposal.',
  },
  {
    question: 'Do I have to use your hosting?',
    answer:
      'No. You can choose Self-Hosted Handoff, Essential Hosting ($25/month), or Managed Hosting + Support ($39/month). Self-hosted options include a one-time setup fee; ongoing maintenance and server support are not included.',
  },
  {
    question: 'What if I am not sure which package I need?',
    answer:
      'Start a project and share your goals. I will recommend Starter, Growth, or a Custom Web Application and send a clear proposal before any work begins.',
  },
];

export const paymentScheduleNote =
  'Typical payment schedule: 50% to start, 50% before launch. Custom schedules are available for larger projects.';
